const Compesation = () => import(/* webpackChunkName: "qraccess" */ "../../views/compesations/Compesation.vue")
const CompesationNew = () => import(/* webpackChunkName: "trips" */ "../../views/compesations/CompesationNew.vue")

const compensationsRoutes = [
    {
        path: "compensations",
        name: "Compensations",
        redirect: {
          name: "New Compensations"
        },
        component: Compesation,
        children: [
          {
            path: "new",
            name: "New Compensations",
            component: CompesationNew
          }
        ]
      }
];

export default compensationsRoutes;